/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Loader from "react-spinners/BeatLoader";

export default function CardTournee({ t, el, tab, visite }) {
  const [loading, setLoading] = useState(false);

  const findElement = (items) => {
    return visite?.filter(
      (element) => element.client_code === items.code
    ) || [];
  };

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      {loading ? (
        <Loader />
      ) : (
        <div className="card box-widget widget-user h-100">
          {/* HEADER */}
          <div className="widget-user-header bg-purple text-center">
            <h4 className="widget-user-username">{el.route.user}</h4>
          </div>

          {/* IMAGE */}
          <div className="widget-user-image">
            <img
              alt="User Avatar"
              className="rounded-circle"
              src="../assets/images/users/2.png"
            />
          </div>

          <div className="box-footer">
            {/* INFOS */}
            <div className="row">
              <div className="col-sm-4 border-right border-top">
                <div className="description-block">
                  <h5 className="description-header text-primary">
                    <Link
                      to={
                        "/tournee/" +
                        el.route.routing_code +
                        "/" +
                        tab.code +
                        "/" +
                        el.route.user_code +
                        "/" +
                        tab.code_jour
                      }
                    >
                      <u className="text-primary">{tab.code}</u>
                    </Link>
                  </h5>
                  <span className="text-muted">
                    {t("tournee.codetournee")}
                  </span>
                </div>
              </div>

              <div className="col-sm-4 border-right border-top">
                <div className="description-block">
                  <h5 className="description-header text-primary">
                    {el.route.routing_code}
                  </h5>
                  <span className="text-muted">
                    {t("detailClient.coderouting")}
                  </span>
                </div>
              </div>

              <div className="col-sm-4 border-top">
                <div className="description-block">
                  <h5 className="description-header text-primary">
                    {tab.frequence}
                  </h5>
                  <span className="text-muted">
                    {t("tournee.frequence")}
                  </span>
                </div>
              </div>
            </div>

            {/* VISITES */}
            <div className="row">
              <div className="col-sm-12 border-top">
                <div className="description-block">
                  <div
                    className="mt-3 mb-3"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",      // 🔥 CLE DU PROBLÈME
                      gap: "4px",
                      justifyContent: "center",
                    }}
                  >
                    {tab.clients.map((items, key) => {
                      const elements = findElement(items);

                      if (elements.length === 0) {
                        return (
                          <div
                            key={key}
                            className="w-4 h-4 bg-danger"
                            title="Non Visité"
                          />
                        );
                      }

                      return elements.map((e, i) => {
                        let color = "bg-danger";
                        let title = "Non Visité";

                        if (e.type === "bl") {
                          color = "bg-lime";
                          title = "BL";
                        } else if (e.type === "visite") {
                          color = "bg-primary";
                          title = "Visite";
                        } else if (e.type === "commande") {
                          color = "bg-success";
                          title = "Commande";
                        } else if (e.type === "recouvrement") {
                          color = "bg-cyan";
                          title = "Recouvrement";
                        }

                        return (
                          <div
                            key={`${key}-${i}`}
                            className={`w-4 h-4 ${color}`}
                            title={title}
                          />
                        );
                      });
                    })}
                  </div>

                  <span className="text-muted">
                    {t("todayCommercial.visites")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
